import { Button, Container, Header, StatusIndicator } from '@amzn/awsui-components-react';
import { Account } from '../../lib/aoc';
import { getProvider } from '../../service/providers';
import { useReportNotMyAccount } from '../../hooks/useReportNotMyAccount';

export type StepHeaderOptions = {
    stepNumber: number;
    account: Account;
    confirmed?: boolean;
};
export const StepHeader = ({ stepNumber, account, confirmed }: StepHeaderOptions) => {
    const { reportNotMyAccount, loading, submitted } = useReportNotMyAccount(account);

    let description = '';
    if (confirmed) {
        description = `Sign in method: ${getProvider(account.idp).readableName}${
            account.email ? `| Email: ${account.email}` : ''
        }`;
    } else {
        description = `Requested sign in method: ${getProvider(account.idp).readableName}${
            account.email ? `| Email: ${account.email}` : ''
        }`;
    }

    const descriptionWithButton = (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>{description}</span>
            {!confirmed && !submitted && (
                <Button variant="link" onClick={reportNotMyAccount} loading={loading}>
                    Not my account
                </Button>
            )}
            {submitted && <span style={{ color: 'green' }}>Reported</span>}
        </span>
    );

    return (
        <Container>
            <Header
                actions={account.email ? <StatusIndicator> Confirmed </StatusIndicator> : <></>}
                description={descriptionWithButton}
            >
                Step {stepNumber}
            </Header>
        </Container>
    );
};
